import { getWorkflowSkeleton } from '../mocks/specs';
import { EnvironmentWorkflow } from '../types/workflows/EnvironmentWorkflow';

export const environmentWorkflow: EnvironmentWorkflow = {
  generating: true,
  generatingFailed: false,
  fetching: true,
  fetchingFailed: false,
  submitStatus: {
    submitting: false,
    failed: false
  },
  steps: {
    environment: {
      fetching: true,
      failed: false,
      datacenters: [],
      environments: []
    },
    selectProduct: {
      fetching: true,
      failed: false,
      products: [],
      binaryMappings: [],
      existingVcfDeployedProductIds: []
    },
    eula: {
      fetching: true,
      failed: false,
      eulaDetails: {
        eula: ''
      }
    },
    infrastructure: {
      fetching: true,
      failed: false,
      vCenters: [],
      properties: []
    },
    binaryMapping: {
      fetching: true,
      failed: false
    },
    network: {
      fetching: true,
      failed: false,
      properties: []
    },
    products: {
      fetching: true,
      failed: false,
      vCenters: [],
      productsMetadata: [],
      productsDisplayMetadata: [],
      vropsLogForwardingEntities: []
    },
    precheck: {
      fetching: true,
      failed: false
    }
  },
  state: getWorkflowSkeleton()
};
